export const NOTIFICATION_TYPE = {
  email: "email",
  sms: "sms",
  emailAndSms: "emailAndSms",
  dontSend: "dontsend",
};
